import "./popup.css";
import { Point } from "josh_js_util";
import React, { createContext, useContext, useEffect, useState } from "react";
import { toClass } from "./index";
var PopupContextImpl = /** @class */ (function () {
    function PopupContextImpl() {
        this.listeners = [];
    }
    PopupContextImpl.prototype.hide = function () {
        var evt = {
            type: "popup-event",
            direction: "below",
            owner: null,
            offset: new Point(0, 0),
            visible: false,
            content: null,
        };
        this.listeners.forEach(function (cb) { return cb(evt); });
    };
    PopupContextImpl.prototype.on_change = function (cb) {
        this.listeners.push(cb);
    };
    PopupContextImpl.prototype.show_at = function (view, owner, direction, offset) {
        var evt = {
            type: "popup-event",
            direction: direction || "right",
            owner: owner,
            offset: offset || new Point(0, 0),
            content: view,
            visible: true,
        };
        this.listeners.forEach(function (cb) { return cb(evt); });
    };
    return PopupContextImpl;
}());
export { PopupContextImpl };
var samplePopupContext = new PopupContextImpl();
export var PopupContext = createContext(samplePopupContext);
export function PopupContainer() {
    var pm = useContext(PopupContext);
    var _a = useState(null), event = _a[0], set_event = _a[1];
    var _b = useState(false), visible = _b[0], set_visible = _b[1];
    useEffect(function () {
        pm.on_change(function (e) {
            set_event(e);
            set_visible(e.visible);
        });
    });
    var clickedScrim = function () {
        set_visible(false);
    };
    var x = 0;
    var y = 0;
    var content = React.createElement("div", null, "\"no content\"");
    console.log("event", event);
    if (event && event.visible) {
        var rect = event.owner.getBoundingClientRect();
        x = rect.left;
        y = rect.top + rect.height;
        if (event.direction === "inside-top-left") {
            x = 0;
            y = 0;
        }
        if (event.direction === 'right') {
            x = rect.left + rect.width;
        }
        content = event.content;
        if (event.offset) {
            x += event.offset.x;
            y += event.offset.y;
        }
    }
    console.log("final xy", x, y);
    var style = {
        left: "".concat(x, "px"),
        top: "".concat(y, "px"),
    };
    return React.createElement("div", { className: toClass({
            popupScrim: true,
            visible: visible,
        }), onClick: clickedScrim },
        React.createElement("div", { className: "popupWrapper", style: style }, content));
}
